import React from "react";

const Logo = (props) => {
  return <img src="/images/govLogo.png" alt="Logo" {...props} />;
};

export default Logo;
